module.exports = __webpack_public_path__ + "static/media/dollar-2-ipswich.f65c859d.png";